import { default as _91_46_46_46catchAll_936FA629IU4uMeta } from "/app/pages/[...catchAll].vue?macro=true";
import { default as indexN6pT4Un8hYMeta } from "/app/pages/index.vue?macro=true";
import { default as loginhHM0vSTW5jMeta } from "/app/pages/login.vue?macro=true";
import { default as _91id_93iIONwq6f0aMeta } from "/app/pages/shared/[id].vue?macro=true";
import { default as _91id_93wc9B8d3yWnMeta } from "/app/pages/shared/message/[id].vue?macro=true";
export default [
  {
    name: "catchAll",
    path: "/:catchAll(.*)*",
    meta: _91_46_46_46catchAll_936FA629IU4uMeta || {},
    component: () => import("/app/pages/[...catchAll].vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexN6pT4Un8hYMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginhHM0vSTW5jMeta || {},
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "shared-id",
    path: "/shared/:id()",
    meta: _91id_93iIONwq6f0aMeta || {},
    component: () => import("/app/pages/shared/[id].vue")
  },
  {
    name: "shared-message-id",
    path: "/shared/message/:id()",
    meta: _91id_93wc9B8d3yWnMeta || {},
    component: () => import("/app/pages/shared/message/[id].vue")
  }
]